import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18n from 'i18next';

import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import TopicImage from '../images/default_topic_cover.svg';

import styles from '../styles/videosTopic.module.scss';

const VideosTopicHeader = ({
  description = '',
  followTopic,
  isFollowed = false,
  name = '',
  picture = {
    alt_text: null,
    url: { w3200: '', w2400: '', w1600: '', w1100: '', w800: '', w550: '' },
  },
  unfollowTopic,
}) => {
  const isDefaultImage = !picture?.url.w2400;
  const CoverElement = isDefaultImage ? 'div' : 'img'

  return (
    <div className={styles.container}>
      <div className={styles.gradient}>
        <div className={classNames(styles.gradientLayer, { [styles.defaultGradient]: isDefaultImage })} />
        <CoverElement
          className={classNames(styles.gradientImage, { [styles.defaultImage]: isDefaultImage })}
          src={picture?.url.w2400 || ''}
          alt={picture?.alt_text || name}
        />
      </div>

      <div className={styles.inner}>
        <div className={styles.content}>
          <div className={styles.contentText}>
            <div className={styles.contentInner}>
              <div className={styles.actionContainer}>
                <Typo className={styles.contextTextName} variant="h1">{name}</Typo>
                <Button
                  onClick={isFollowed ? unfollowTopic : followTopic}
                  className={styles.action}
                  variant="outlined"
                  text={i18n.t(isFollowed ? 'unfollow' : 'follow')}
                  icon={isFollowed ? <Remove /> : <Add />}
                  iconClass={styles.actionIcon}
                  color="white"
                />
              </div>
              <Typo variant="h6">{description}</Typo>
            </div>
          </div>
        </div>

        <div className={styles.imageContainer}>
          <div>
            {picture?.url.w2400
              ? (
                <img
                  className={styles.cover}
                  src={picture?.url.w2400 || '/assets/student/default_topic_cover.svg'}
                  alt={picture?.alt_text || name}
                />
              )
              : <TopicImage />}
          </div>
        </div>
      </div>
    </div>
  );
};

VideosTopicHeader.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  isFollowed: PropTypes.bool,
  picture: PropTypes.shape({
    alt_text: PropTypes.string,
    url: PropTypes.shape({
      w3200: PropTypes.string,
      w2400: PropTypes.string,
      w1600: PropTypes.string,
      w1100: PropTypes.string,
      w800: PropTypes.string,
      w550: PropTypes.string,
    }),
  }),
};

export default React.memo(VideosTopicHeader);
